import { useState, useEffect } from "react";
import Aadhaar from "./Aadhaar";
import moment from "moment";
import {
  downloadUserDataByDateRangeAndApiId,
  getApiHitTrendByDataRangeApiId,
  getApiOverallSummaryByDateStatus,
  getUserDataByDateRangeAndApiId,
} from "../ActionCreator";
import CustomDateFilter from "../common/CustomDateFilter";
import "../Dashboard.scss";

import { downloadCSV } from "../lib/downloadCsv";
import { ChevronLeft } from "lucide-react";
import CustomDatePicker from "../../../../CustomDatePicker/CustomDateFilter";
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelect";

export default function KYCMain({
  activeSubTab,
  handleBack,
  dateFilterPopup,
  setDateFilterPopup,
  dateType,
  setDateType,
  updateDateRange,
}) {
  const MAP_CONFIG = {
    aadhaar: {
      apiId: "Oj2Kq8PzF5wA1UtD",
      heading: "Aadhar eKYC",
    },
    aadhaarValidation: {
      apiId: "LlKq8PeF5n7YUtH",
      heading: "Aadhar Validation",
    },
    pan: {
      apiId: "Rl2Lr8NaF5wC1StE",
      heading: "Pan",
    },
    bav: {
      apiId: "Pl2Lr8NaG5wC1VtL",
      heading: "BAV",
    },
    pdfParseNetbanking: {
      apiId: "8ZvLdG6x9P2J7tQY",
      heading: "PDF Parsing by Netbanking",
    },
    pdfParseUpload: {
      apiId: "t5R9x2q8L1m7y6N4",
      heading: "PDF Parsing by Doc Upload",
    },
    crif: {
      apiId: "f9EoFbBo9gDY7Tbp",
      heading: "CRIF",
    },
    esign: {
      apiId: "56e4aspzipaypmjh",
      heading: "eSign Electronic",
    },
    emandateRegistration: {
      apiId: "qu7a53abef5fpbl5",
      heading: "e-mandate Registration",
    },
  };

  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  // const [dateFilterPopup, setDateFilterPopup] = useState({
  //   show: false,
  //   from: moment(new Date()).format("YYYY-MM-DD"),
  //   to: moment(new Date()).format("YYYY-MM-DD"),
  //   initialType: "today",
  // });

  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [noOfRows, setNoOfRows] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [statsOption, setStatsOption] = useState({
    "API Name": `${MAP_CONFIG[activeSubTab]?.title} API`,
    Vendor: "UIDAI / Partner",
    "SLA Breaches": "0%",
    "Total Hits": "0",
    "Impacted Loans": "0",
    "Total Cost": "₹0",
    "Cost Per Hits": "₹0",
    "Success Rate": "0%",
    "Failure Rate": "0%",
  });
  const [chartData, setchartData] = useState([]);
  const [isFilterCleared, setIsFilterCleared] = useState(false);

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
  };

  const handleApplyDteFilter = () => {
    handleDateFilterPopup("show", false);
    handleApply();
  };

  const fetchSummaryAndTrend = (customDate) => {
    if (!MAP_CONFIG[activeSubTab]?.apiId) return;

    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");

    setIsSummaryLoading(true);

    let summaryDone = false;
    let trendDone = false;

    const stopLoaderIfDone = () => {
      if (summaryDone && trendDone) {
        setIsSummaryLoading(false);
      }
    };

    getApiOverallSummaryByDateStatus(
      sDate,
      eDate,
      "",
      MAP_CONFIG[activeSubTab]?.apiId,
      (summaryRes) => {
        setStatsOption({
          "API Name": `${MAP_CONFIG[activeSubTab]?.heading} API`,
          Vendor: Object.keys(summaryRes?.data || {})[0] || "-",
          "Total API Hits": summaryRes?.totalApiHits ?? "-",
          "Total API Cost": `₹${summaryRes?.totalApiCost ?? "-"}`,
          "Avg Cost per Loan Applied": `₹${summaryRes?.avgCostPerLoanApplied ?? "-"}`,
          "Avg Cost Per Customer": `₹${summaryRes?.avgCostPerCustomer ?? "-"}`,
          "Success Rate": `${summaryRes?.successRate ?? "-"}%`,
          "Failure Rate": `${summaryRes?.failureRate ?? "-"}%`,
        });

        summaryDone = true;
        stopLoaderIfDone();
      },
    );

    getApiHitTrendByDataRangeApiId(
      sDate,
      eDate,
      "daily",
      MAP_CONFIG[activeSubTab]?.apiId,
      (trendRes) => {
        setchartData(trendRes?.data?.data ?? []);

        trendDone = true;
        stopLoaderIfDone();
      },
    );
  };

  const fetchUserTable = (page, size, customDate) => {
    if (!MAP_CONFIG[activeSubTab]?.apiId) return;

    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");

    setIsTableLoading(true);

    getUserDataByDateRangeAndApiId(
      page,
      size,
      sDate,
      eDate,
      MAP_CONFIG[activeSubTab]?.apiId,
      (userRes) => {
        setTableData(userRes?.data?.data ?? []);
        setTotalCount(userRes?.data?.totalCount ?? 0);

        setIsTableLoading(false);
      },
    );
  };

  useEffect(() => {
    if (!MAP_CONFIG[activeSubTab]?.apiId) return;

    setPageNumber(1);

    fetchSummaryAndTrend(dateFilterPopup);
    fetchUserTable(1, noOfRows, dateFilterPopup);
  }, [MAP_CONFIG[activeSubTab]?.apiId, dateFilterPopup]);

  useEffect(() => {
    if (!MAP_CONFIG[activeSubTab]?.apiId) return;

    fetchUserTable(pageNumber, noOfRows, dateFilterPopup);
  }, [pageNumber, noOfRows]);

  const handleApply = () => {
    setPageNumber(1);
    fetchSummaryAndTrend(dateFilterPopup);
    fetchUserTable(1, noOfRows, dateFilterPopup);
  };

  const handleReset = () => {
    const today = moment().format("YYYY-MM-DD");

    const resetDate = {
      show: false,
      from: today,
      to: today,
      initialType: "today",
    };
    setIsFilterCleared(true);

    setDateFilterPopup(resetDate);
    fetchSummaryAndTrend(resetDate);
    fetchUserTable(1, noOfRows, resetDate);
  };

  const handleExport = () => {
    const config = MAP_CONFIG[activeSubTab];
    if (!config?.apiId) return;

    const sDate = moment(dateFilterPopup?.from).format("DD-MM-YYYY");
    const eDate = moment(dateFilterPopup?.to).format("DD-MM-YYYY");

    setIsBtnLoading(true);
    downloadUserDataByDateRangeAndApiId(
      sDate,
      eDate,
      config.apiId,
      (response) => {
        setIsBtnLoading(false);
        if (!response) return;
        const rows = response?.data?.data ?? [];
        if (!rows.length) {
          console.warn("No data available for export");
          return;
        }
        downloadCSV(rows, `${config.heading}_${sDate}_to_${eDate}`);
      },
    );
  };

  return (
    <>
      <div className="OverView-Main-Section min-size-1800">
        <div className="topsTabs">
          <div className="leftTabs">
            <button className={`customTabsBtn active`}>API Wise</button>
          </div>
          <div className="rightTabs">
            <button className="rightSideBtn">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.35449 6.49984C1.35449 4.07407 1.35449 2.86119 2.10808 2.10759C2.86167 1.354 4.07456 1.354 6.50033 1.354C8.92607 1.354 10.139 1.354 10.8926 2.10759C11.6462 2.86119 11.6462 4.07407 11.6462 6.49984C11.6462 8.92558 11.6462 10.1385 10.8926 10.8921C10.139 11.6457 8.92607 11.6457 6.50033 11.6457C4.07456 11.6457 2.86167 11.6457 2.10808 10.8921C1.35449 10.1385 1.35449 8.92558 1.35449 6.49984Z"
                  stroke="#686C70"
                  stroke-width="0.8125"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.41699 8.396C5.41699 8.84471 5.05323 9.2085 4.60449 9.2085C4.15576 9.2085 3.79199 8.84471 3.79199 8.396C3.79199 7.94728 4.15576 7.5835 4.60449 7.5835C5.05323 7.5835 5.41699 7.94728 5.41699 8.396Z"
                  stroke="#686C70"
                  stroke-width="0.8125"
                />
                <path
                  d="M9.20801 4.604C9.20801 4.15527 8.84422 3.7915 8.39551 3.7915C7.94679 3.7915 7.58301 4.15527 7.58301 4.604C7.58301 5.05274 7.94679 5.4165 8.39551 5.4165C8.84422 5.4165 9.20801 5.05274 9.20801 4.604Z"
                  stroke="#686C70"
                  stroke-width="0.8125"
                />
                <path
                  d="M4.60449 7.58317V3.7915"
                  stroke="#686C70"
                  stroke-width="0.8125"
                  stroke-linecap="round"
                />
                <path
                  d="M8.39551 5.4165V9.20817"
                  stroke="#686C70"
                  stroke-width="0.8125"
                  stroke-linecap="round"
                />
              </svg>
              API Configuration
            </button>
            {/* <button
              className="rightSideBtn-dark"
              onClick={handleExport}
              disabled={isBtnLoading}
              style={{ cursor: isBtnLoading ? "not-allowed" : "pointer" }}
            >
              {isBtnLoading ? (
                <>
                  <svg
                    className="spinner"
                    width="13"
                    height="13"
                    viewBox="0 0 50 50"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      stroke="#fff"
                      stroke-width="5"
                      stroke-linecap="round"
                    />
                  </svg>
                  Exporting...
                </>
              ) : (
                <>
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.58366 11.6458H5.41699C3.63627 11.6458 2.74591 11.6458 2.14664 11.1539C2.03693 11.0639 1.93634 10.9633 1.8463 10.8536C1.35449 10.2543 1.35449 9.36398 1.35449 7.58325C1.35449 5.80252 1.35449 4.91217 1.8463 4.3129C1.93634 4.20319 2.03693 4.1026 2.14664 4.01256C2.74591 3.52075 3.63627 3.52075 5.41699 3.52075H7.58366C9.36439 3.52075 10.2547 3.52075 10.854 4.01256C10.9637 4.1026 11.0643 4.20319 11.1543 4.3129C11.6462 4.91217 11.6462 5.80252 11.6462 7.58325C11.6462 9.36398 11.6462 10.2543 11.1543 10.8536C11.0643 10.9633 10.9637 11.0639 10.854 11.1539C10.2547 11.6458 9.36439 11.6458 7.58366 11.6458Z"
                      stroke="white"
                      stroke-width="0.8125"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M1.35449 7.85425V5.68758C1.35449 3.64483 1.35449 2.62345 1.98909 1.98885C2.6237 1.35425 3.64507 1.35425 5.68783 1.35425H7.31283C9.35556 1.35425 10.377 1.35425 11.0115 1.98885C11.6462 2.62345 11.6462 3.64483 11.6462 5.68758V7.85425"
                      stroke="white"
                      stroke-width="0.8125"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.125 7.85417C8.125 7.85417 6.92819 9.47911 6.5 9.47911C6.07176 9.47917 4.875 7.85411 4.875 7.85411M6.5 9.20833V5.6875"
                      stroke="white"
                      stroke-width="0.8125"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Export
                </>
              )}
            </button> */}
          </div>
        </div>

        <div className="HeadingFilter-Section">
          <div
            style={{
              marginTop: "25px",
              marginBottom: "10px",
            }}
          >
            <h4
              onClick={(e) => handleBack(e)}
              style={{
                margin: 0,
                color: "#1f2937",
                // width: "700px",
                display: "flex",
                gap: "5px",
                alignItems: "center",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              <ChevronLeft />
              {MAP_CONFIG[activeSubTab]?.heading}
            </h4>
          </div>
        </div>

        <div className="HeadingFilter-main-filters">
          <div className="row">
            <div
              className="col-xl-9 col-lg-10 col-xs-12"
              style={{ display: "flex", gap: "10px", marginTop: "5px" }}
            >
              {/* <div className='customInputSearch-bar' style={{ width: window.innerWidth > 1200 ? '35%' : "auto" }}>
                                          <i className='fa fa-search'></i>
                                          <input placeholder='Search' className='customInput' value={payload?.search} onChange={(e) => handlechange(e, "search")} />
                                        </div> */}

              {/* <div className="custom-popup" style={{ width: "25%" }}>
                <div
                  className="customSelectBox "
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleDateFilterPopup("show", !dateFilterPopup?.show)
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "7px",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 0.75V2.25M3 0.75V2.25"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1.125 3.75H7.875"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    {dateFilterPopup?.from && dateFilterPopup?.to
                      ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                      : "Select Date Range"}
                  </div>
                  <div style={{ marginTop: "-5px" }}>
                    <svg
                      width="8"
                      height="4"
                      viewBox="0 0 8 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375"
                        stroke="#686C70"
                        stroke-width="0.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                {dateFilterPopup?.show ? (
                  <CustomDateFilter
                    payload={dateFilterPopup}
                    handlechange={handleDateFilterPopup}
                    handleApply={handleApplyDteFilter}
                  />
                
                ) : (
                  ""
                )}
              </div> */}
              {/* <CustomDatePicker
                onChange={(range) =>
                  handleDateFilterPopup(
                    "from",
                    range[0]?.format("YYYY-MM-DD"),
                  ) ||
                  handleDateFilterPopup("to", range[1]?.format("YYYY-MM-DD"))
                }

              /> */}

              <DateFilterSelect
                onChange={(range) => {
                  updateDateRange(range[0], range[1], "custom");
                }}
                isFilterCleared={isFilterCleared}
                type={dateType}
                onTypeChange={setDateType}
                dateFilterPopup={dateFilterPopup}
              />
            </div>
            <div
              className="col-xl-3 col-lg-2 col-xs-12"
              style={{ marginTop: "5px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: window.innerWidth > 1200 ? "end" : "start",
                }}
              >
                {/* <div className='custom-btn' role='button' onClick={handleApply}>
                  <i class="fa fa-filter" style={{
                    fontSize: window.innerWidth >= 1800 ? '20px' : ''
                  }} aria-hidden="true" ></i>
                </div> */}
                <div
                  className="custom-btn"
                  role="button"
                  onClick={handleExport}
                >
                  <i
                    class="fa fa-download"
                    style={{
                      fontSize: window.innerWidth >= 1800 ? "20px" : "",
                    }}
                    aria-hidden="true"
                  ></i>
                </div>
                <div className="custom-btn" role="button" onClick={handleReset}>
                  <i
                    class="fa fa-times"
                    style={{
                      fontSize: window.innerWidth >= 1800 ? "20px" : "",
                    }}
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div style={{ marginTop: "16px" }}>
          <div
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: "12px",
              padding: "6px 16px",
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <h5
                style={{
                  margin: 0,
                  fontWeight: 600,
                  color: "#1f2937",
                  width: "700px",
                }}
              >
                {MAP_CONFIG[activeSubTab]?.heading}
              </h5>
              

              <input
                type="date"
                value={date?.from}
                onChange={(e) => handleDateChange("start", e.target.value)}
                style={{
                  height: "30px",
                  padding: "6px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  flex: 1,
                }}
              />

              <input
                type="date"
                value={date.to}
                onChange={(e) => handleDateChange("end", e.target.value)}
                style={{
                  height: "30px",
                  padding: "6px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  flex: 1,
                }}
              />

              <div
                className=""
                style={{
                  height: "30px",
                  padding: "5px 13px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor:
                    !date.from || !date.to ? "#9ca3af" : "#045865",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: !date.from || !date.to ? "not-allowed" : "pointer",
                  transition: "background-color 0.2s ease",
                  whiteSpace: "nowrap",
                }}
                onClick={handleApply}
              >
                <i className="fa fa-filter" aria-hidden="true"></i>
              </div>

              <div
                className=""
                style={{
                  height: "30px",
                  padding: "5px 13px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor:
                    !date.from || !date.to ? "#9ca3af" : "#045865",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: !date.from || !date.to ? "not-allowed" : "pointer",
                  transition: "background-color 0.2s ease",
                  whiteSpace: "nowrap",
                }}
                onClick={handleReset}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className='HeadingFilter-Section'>
                    <div>
                        <h4>{activeSubTab == "aadhaar" ? "Aadhar eKYC" : activeSubTab === 'aadhaarValidation' ? 'Aadhar Validation' : activeSubTab === 'pan' ? 'Pan' :'' }</h4>
                    </div>
                </div> */}

        {MAP_CONFIG[activeSubTab] && (
          <Aadhaar
            apiId={MAP_CONFIG[activeSubTab]?.apiId}
            heading={MAP_CONFIG[activeSubTab]?.heading}
            isSummaryLoading={isSummaryLoading}
            isTableLoading={isTableLoading}
            statsOption={statsOption}
            chartData={chartData}
            tableData={tableData}
            totalCount={totalCount}
            setNoOfRows={setNoOfRows}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            noOfRows={noOfRows}
          />
        )}
      </div>
    </>
  );
}
